<template>
    <b-card
        no-body
        border-variant="light"
    >
        <div class="card-header">
            <div class="col-md-6 pl-0">
                <b-card-title>{{ $t('Page(SendRequest):Component(Label):email') }}</b-card-title>
            </div>
            <div class="col-md-6 pr-0">
            </div>
        </div>
        <div class="pl-2 pr-2 pb-2">
            <b-form-group
                :label="$t('Page(SendRequest):Component(Label):email-subject')"
                label-for="subject"
            >
                <b-form-input
                    disabled
                    id="subject"
                    placeholder="Subject"
                    v-model="email.subject"
                />
            </b-form-group>
            <b-form-group
                :label="$t('Page(SendRequest):Component(Label):email-message')"
                label-for="message"
            >
                <p class="pt-1" v-html="email.body"/>
            </b-form-group>
        </div>
    </b-card>
</template>

<script>
import { BFormInput, BCardTitle, BCard, BFormGroup, BListGroup, BFormTextarea } from 'bootstrap-vue'
import {ProductApi} from "@core/api";

export default {
    components: {
        BFormInput, BCardTitle, BCard, BFormGroup, BListGroup, BFormTextarea,
    },
    props: {
        supplierNameDefault: {
            type: String,
            default: '{suppliers name will replace this text}'
        },
        supplierName: {
            default: null
        }
    },
    data() {
        return {
            email: {
                subject: 'Request for information on substances in articles',
                body: ''
            },
        };
    },
    computed: {
        supplier() {
            return this.supplierName || this.supplierNameDefault;
        },
    },
    created() {
        ProductApi.emailMessageExample().then(response => this.email = response.data);
    }
}
</script>
